import { render, staticRenderFns } from "./MonthlyAutoInvestDirectBilling.vue?vue&type=template&id=6165fe10&"
import script from "./MonthlyAutoInvestDirectBilling.vue?vue&type=script&lang=js&"
export * from "./MonthlyAutoInvestDirectBilling.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyAutoInvestDirectBilling.vue?vue&type=style&index=0&id=6165fe10&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports